module.exports = __webpack_public_path__ + "img/question-icon.7d04439d.svg";